<script setup lang="ts">
/**
 * 403. Доступ к проекту даёт членство, а приватный проект не виден и по
 * прямой ссылке — так что это штатный экран, а не аварийный.
 *
 * В макете CTA называется «Запросить доступ», но такой ручки в трекере нет
 * (DEV-1493). До неё кнопка уводит к своим задачам: подпись, которая ничего
 * не делает, хуже честной навигации.
 */
import { AppButton } from '@vinprop/design-system'
import { Eye } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import TrackerEmptyState from '@/components/TrackerEmptyState.vue'

const { t } = useI18n()
const router = useRouter()
</script>

<template>
  <TrackerEmptyState
    :icon="Eye"
    :title="t('errors.forbidden.title')"
    :description="t('errors.forbidden.description')"
    tint="var(--color-warning-tint)"
  >
    <AppButton variant="primary" @click="router.push('/my')">{{ t('errors.back') }}</AppButton>
  </TrackerEmptyState>
</template>
